import { FunctionComponent } from 'react';

import styles from './TitleWithSeparator.module.sass';
import Separator from './Separator';

const TitleWithSeparator: FunctionComponent = ({ children }) => {
    return (
        <>
            <div className={styles.title}>{children}</div>
            <Separator />
        </>
    );
};

export default TitleWithSeparator;
